import React, { Component } from 'react'
import { PrimaryH2, SecondaryP } from './styled-components.js'

export default class ItemListBlock extends Component {
  render() {
    const { component } = this.props

    return (
      <section
        className={`component item-list-block margin-${component.marginBelow}`}
      >
        <figcaption>
          {component.blockTitle && (
            <div className="grid-row">
              <div className="title">
                <PrimaryH2 primaryTextColor={component.primaryColor}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: component.blockTitle,
                    }}
                  />
                </PrimaryH2>
              </div>
            </div>
          )}
          {component.blockCopyListItems && (
            <div className="grid-row">
              <div className="list-items">
                <SecondaryP secondaryTextColor={component.secondaryColor}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: component.blockCopyListItems.blockCopyListItems,
                    }}
                  />
                </SecondaryP>
              </div>
            </div>
          )}
        </figcaption>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared-page-components/item-list-block.js